import { pipe } from 'ramda';
import { Category } from 'api/timesheets/categories';
import {
  Creating,
  Deleting,
  Empty,
  Loaded,
  Loading,
  Updating,
} from 'core/state';

export type CategoriesStore = {
  byId: Record<
    number,
    | Loaded<Category>
    | Creating<Category>
    | Updating<Category>
    | Deleting<Category>
  >;
  ids: Empty | Loading | Loaded<number[]>;
  creating: {
    byId: Record<string, number>;
    ids: string[];
  };
};

declare const CategoriesType: unique symbol;
export type Categories = { readonly type: typeof CategoriesType };

export const from = (x: Categories): CategoriesStore =>
  x as unknown as CategoriesStore;
export const to = (x: CategoriesStore): Categories =>
  x as unknown as Categories;

const _empty: CategoriesStore = {
  byId: {},
  ids: Empty(),
  creating: {
    byId: {},
    ids: [],
  },
};

export const empty = pipe(() => _empty, to);
